module.exports = __webpack_public_path__ + "static/media/stellar.9b830828.png";